// extracted by mini-css-extract-plugin
export default {"container":"g__container--efdyr","alert":"g__alert--UxSzR","content--inline":"g__content--inline--CQrBB","button":"g__button--Y1Opr"};